import { useState } from "react";

export function sortByDate(data) {
  var today = new Date();
  var limit = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 30
  );

  var dates = [];
  for (let i = 30; i > -1; i--) {
    var limit = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - i
    );
    dates.push(limit.toDateString());
  }

  var list = [];
  data.map((obj) => {
    if (dates.indexOf(obj.dateCreated.toDate().toDateString()) !== -1) {
      list.push(obj);
    }
  });

  list.sort((a, b) => a.dateCreated.toDate() - b.dateCreated.toDate());

  return list.reverse();
}
